import Icon from '@/components/icon';
import { IconType } from '@/components/icon/helpers';
import {
  TimelineItem as MuiTimelineItem,
  TimelineDot,
  TimelineConnector,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineContent,
} from '@mui/lab';
import { Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  leftNode: ReactNode;
  timelineImage?: string;
  timelineImageAlt?: string;
  timelineIcon?: IconType;
  isLastItem?: boolean;
  children: ReactNode;
}

const useStyles = createUseStyles((theme: Theme) => ({
  timelineItem: {
    '&:hover': {
      backgroundColor: theme.palette.surface.info.main,
    },
  },
  date: {
    padding: '12px 8px 0px 0px',
    flex: '0.15 !important',
  },
  timelineImage: {
    width: 22,
    height: 22,
    borderRadius: 4,
  },
  dot: {
    backgroundColor: theme.palette.surface.info.main,
    borderColor: theme.palette.surface.info.main,
    boxShadow: 'none',
  },
  timelineIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: theme.palette.common.black,
    borderRadius: 4,
  },
  timelineContent: {
    paddingTop: 12,
    minWidth: 0,
  },
}));

const TimelineItem: FC<Props> = ({
  leftNode,
  timelineImage,
  timelineImageAlt,
  timelineIcon,
  isLastItem,
  children,
}) => {
  const styles = useStyles();

  const hasImage = !!timelineImage;
  return (
    <MuiTimelineItem className={styles.timelineItem}>
      <TimelineOppositeContent className={styles.date} color="textSecondary">
        {leftNode}
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot className={styles.dot}>
          {hasImage ? (
            <img
              src={timelineImage}
              className={styles.timelineImage}
              alt={timelineImageAlt || ''}
            />
          ) : (
            <Icon
              name={timelineIcon || 'question-mark'}
              color="white"
              className={styles.timelineIcon}
              size="small"
            />
          )}
        </TimelineDot>
        {!isLastItem && <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent className={styles.timelineContent}>{children}</TimelineContent>
    </MuiTimelineItem>
  );
};

export default TimelineItem;
